import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

export const ConditionalToastContainer = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  if (isAdminPage) {
    return null;
  }

  return <ToastContainer limit={4} />;
};
